import React, { MouseEvent } from "react";
import MFASetupModal from "./MFASetupModal";

interface MFASetupTriggerProps {
  buttonLabel: string;
}

interface MFASetupTriggerState {
  isOpen: boolean;
}

export default class MFASetupTrigger extends React.Component<
  MFASetupTriggerProps,
  MFASetupTriggerState
> {
  state = {
    isOpen: false,
  };

  render(): JSX.Element {
    return (
      <>
        <button
          className="btn btn-primary"
          type="button"
          onClick={this.handleClickOpen}
        >
          {this.props.buttonLabel}
        </button>

        <MFASetupModal
          isOpen={this.state.isOpen}
          onAcknowledge={this.handleClickAcknowledge}
          onClose={this.handleClickClose}
        />
      </>
    );
  }

  handleClickOpen = (e: MouseEvent): void => {
    e.stopPropagation();
    this.setState({ isOpen: true });
  };

  handleClickClose = (): void => {
    this.setState({ isOpen: false });
  };

  handleClickAcknowledge = (): void => {
    this.setState({ isOpen: false });
    window.location.reload();
  };
}
